export default "__VITE_ASSET__DSzw$9OV__"